import { render } from "./radio-group.vue?vue&type=template&id=1be65a8c"
import script from "./radio-group.vue?vue&type=script&lang=js"
export * from "./radio-group.vue?vue&type=script&lang=js"

import "./radio-group.vue?vue&type=style&index=0&id=1be65a8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__